<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #itemChipList>
    <mat-chip-row
      *ngFor="let item of selectedItems"
      [removable]="removable"
      (removed)="removeElement(selectedItemsControl, item)"
    >
      <span cropText>
        <span *ngFor="let key of optionNameKeys; let i = index">
          {{ i === 0 ? item[key] : '| ' + item[key] }}
        </span>
      </span>
      <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-row>
    <input
      #itemInput
      [formControl]="itemInputControl"
      [matAutocomplete]="itemAutocomplete"
      [matChipInputFor]="itemChipList"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="onInputBlur(itemInput)"
    />
  </mat-chip-grid>
  <mat-autocomplete
    #itemAutocomplete="matAutocomplete"
    [panelWidth]="panelWidth"
    (optionSelected)="addOptionElement(selectedItemsControl, itemInput, itemInputControl)"
  >
    <mat-option *ngFor="let item of filteredItems" [value]="item">
      <span *ngFor="let key of optionNameKeys; let i = index">
        {{ i === 0 ? item[key] : '| ' + item[key] }}
      </span>
    </mat-option>
  </mat-autocomplete>
  <ui-svg-icon
    *ngIf="isIconVisible && selectedItemsControl?.value?.length < 2"
    [name]="iconNames.ListView"
    matSuffix
  ></ui-svg-icon>
</mat-form-field>
